package de.oevbs.kunde.kundenportal2.authentication

import de.oevbs.kosmos.ui.overlays.modals.BusyTracker
import de.oevbs.kunde.kundenportal2.PortalMessages
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.sfa.authentication.AuthenticationParameter
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.remote.http
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow
import kotlinx.serialization.json.Json

class LoginDataStore(job: Job) : ValidatingStore<UserLoginData, Unit, ComponentValidationMessage>(
    initialData = UserLoginData(),
    validation = UserLoginData.validation,
    metadataDefault = Unit,
    validateAfterUpdate = false,
    job = job
) {
    private val authRequest = http("/kundenportal2/auth")
    private val json = Json { ignoreUnknownKeys = true }

    val handleAuthentication = handleAndEmit { userLogin ->
        val principal = authenticate(userLogin)
        if (principal != null) emit(principal)
        userLogin
    }

    private suspend fun authenticate(userLogin: UserLoginData): PortalPrincipal? {
        GlobalServiceMessagesStore.clear(Unit)

        if (!validate(userLogin, Unit).valid) return null

        val userAuthentication: PortalPrincipal = globalSubmitTracker.track {
            checkLoginData(userLogin.username, userLogin.password)
        }

        if ((userAuthentication.token != null) && userAuthentication.token?.isNotEmpty() == true) {
            PortalSession.portalLogin(userAuthentication)
            return userAuthentication
        }

        return null
    }

    private suspend fun checkLoginData(user: String, pass: String): PortalPrincipal {
        val response = authRequest.basicAuth(user, pass).get("/info")

        if (!response.ok) {
            GlobalServiceMessagesStore.add(
                when (response.status) {
                    403 -> PortalMessages.loginNotAuthorized
                    else -> PortalMessages.loginCouldNotLogin.also {
                        console.error("Fehler beim Login : ${response.status}, ${response.body()}")
                    }
                }
            )
            return PortalPrincipal()
        }

        val token: String? = response.headers.get(AuthenticationParameter.HEADER_TOKEN)
        val body = response.body()

        val portalPrincipal: PortalPrincipal = json
            .decodeFromString(PortalPrincipal.serializer(), body)

        return portalPrincipal.copy(token = token)
    }
}